import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { IRegisterSectionOptions, TNavSections, TSectionsKeys } from './types';

export const sectionsHashes: Record<TSectionsKeys, string> = {
  aboutCompany: 'about-company',
  aboutProject: 'about-project',
  businessIdea: 'business-idea',
  productsAndServices: 'products-and-services',
  marketAndSales: 'market-and-sales',
  marketAnalysis: 'market-analysis',
  financialProjections: 'financial-projections',
  financingNeeds: 'financing-needs',
  team: 'team',
  implementationPlan: 'implementation-plan',
  contacts: 'contacts',
};

export const useGetNavSections = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const navSections: IRegisterSectionOptions[] = [
      {
        name: t('aboutTheCompany'),
        index: 1,
        hash: sectionsHashes.aboutCompany,
      },
      {
        name: t('chapters.ABOUT_THE_PROJECT'),
        index: 2,
        hash: sectionsHashes.aboutProject,
      },
      {
        name: t('onePageMapping.businessIdea'),
        index: 3,
        hash: sectionsHashes.businessIdea,
      },
      {
        name: t('chapters.FOR_BANK_PRODUCTS_AND_SERVICES'),
        index: 4,
        hash: sectionsHashes.productsAndServices,
      },
      {
        name: t('chapters.FOR_BANK_MARKETING_AND_SALES'),
        index: 5,
        hash: sectionsHashes.marketAndSales,
      },
      {
        name: t('onePageMapping.marketAnalysisStrategy'),
        index: 6,
        hash: sectionsHashes.marketAnalysis,
      },
      {
        name: t('chapters.FINANCIAL_PROJECTIONS'),
        index: 7,
        hash: sectionsHashes.financialProjections,
      },
      {
        name: t('chapters.FINANCING_NEEDS'),
        index: 8,
        hash: sectionsHashes.financingNeeds,
      },
      {
        name: t('chapters.TEAM'),
        index: 9,
        hash: sectionsHashes.team,
      },
      {
        name: t('chapters.IMPLEMENTATION_PLAN'),
        index: 10,
        hash: sectionsHashes.implementationPlan,
      },
      {
        name: t('onePageMapping.contacts'),
        index: 11,
        hash: sectionsHashes.contacts,
      },
    ];
    return navSections;
  }, [t, i18n]);
};

export const navSections: TNavSections = {
  aboutCompany: {
    name: t('aboutTheCompany'),
    index: 1,
    hash: sectionsHashes.aboutCompany,
  },
  aboutProject: {
    name: t('chapters.ABOUT_THE_PROJECT'),
    index: 2,
    hash: sectionsHashes.aboutProject,
  },
  businessIdea: {
    name: t('onePageMapping.businessIdea'),
    index: 3,
    hash: sectionsHashes.businessIdea,
  },
  productsAndServices: {
    name: t('chapters.FOR_BANK_PRODUCTS_AND_SERVICES'),
    index: 4,
    hash: sectionsHashes.productsAndServices,
  },
  marketAndSales: {
    name: t('chapters.FOR_BANK_MARKETING_AND_SALES'),
    index: 5,
    hash: sectionsHashes.marketAndSales,
  },
  marketAnalysis: {
    name: t('onePageMapping.marketAnalysisStrategy'),
    index: 6,
    hash: sectionsHashes.marketAnalysis,
  },
  financialProjections: {
    name: t('chapters.FINANCIAL_PROJECTIONS'),
    index: 7,
    hash: sectionsHashes.financialProjections,
  },
  financingNeeds: {
    name: t('chapters.FINANCING_NEEDS'),
    index: 8,
    hash: sectionsHashes.financingNeeds,
  },
  team: {
    name: t('chapters.TEAM'),
    index: 9,
    hash: sectionsHashes.team,
  },
  implementationPlan: {
    name: t('chapters.IMPLEMENTATION_PLAN'),
    index: 10,
    hash: sectionsHashes.implementationPlan,
  },
  contacts: {
    name: t('onePageMapping.contacts'),
    index: 11,
    hash: sectionsHashes.contacts,
  },
};
